import { useEffect, useRef } from 'react';
// hook obsługujący obsługę poprzedniej wartości

export function usePrevious<T>(value: T): T | undefined {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}
